import { css } from '@emotion/react';
import { theme } from '../../../../domain/theme';

export const contentPackageSmallStyle = bgColor => {
  const isLightBg = ['white', '#f7f7f7'].includes(bgColor);
  return {
    container: css`
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 20px;
    `,
    image: {
      container: css`
        position: relative;
      `,
      picture: undefined,
      cta: css`
        position: absolute;
        bottom: 12px;
        left: 12px;
        z-index: 1;
        background-color: rgba(0, 0, 0, 0.5);
        width: 40px;
        height: 40px;
        border-radius: 100%;
        display: grid;
        place-content: center;
        &:hover {
          background-color: #fc0;
          svg {
            color: black;
          }
        }
        ${theme.mq.large_desktop} {
          width: 48px;
          height: 48px;
        }
        svg {
          color: #fc0;
          display: block;
          ${theme.mq.large_desktop} {
            width: 32px;
            height: 32px;
          }
        }
      `
    },
    text: {
      container: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        ${theme.mq.tablet} {
          gap: 16px;
        }
      `,
      sponsored: css`
        div {
          background-color: ${isLightBg ? 'black' : 'white'};
          color: ${isLightBg ? 'white' : 'black'};
        }
      `,
      taxonomy: css`
        display: flex;
        align-items: flex-start;
        ${theme.font.family('boldWeb')};
        font-size: 0.75rem;
        line-height: 1.375rem;
        letter-spacing: 3px;
        text-transform: uppercase;
        color: ${isLightBg ? '#555' : '#e0e0e0'};
        span:not(:first-of-type) {
          margin-left: 15px;
          padding-left: 15px;
          border-left: 2px solid currentColor;
        }
        a {
          color: inherit;
          transition: all 0.125s ease-in;
          :hover {
            text-decoration: underline;
          }
        }
      `,
      title: css`
        ${theme.font.family('medium')};
        font-size: 1.375rem;
        line-height: 1.75rem;
        letter-spacing: 0.1px;
        font-weight: unset;
        color: ${isLightBg ? 'black' : 'white'};
        a {
          color: inherit;
          :hover {
            text-decoration: underline;
          }
        }
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        ${theme.mq.tablet} {
          -webkit-line-clamp: 5;
        }
        ${theme.mq.small_desktop} {
          -webkit-line-clamp: 4;
        }
      `,
      subtitle: css`
        ${theme.font.family('regular')};
        font-size: 1rem;
        line-height: 1.5rem;
        letter-spacing: 0.1px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5;
        ${theme.mq.tablet} {
          -webkit-line-clamp: 6;
        }
        ${theme.mq.small_desktop} {
          -webkit-line-clamp: 4;
        }
      `,
      cta: css`
        color: ${isLightBg ? 'black' : 'white'};
        button,
        a {
          color: inherit;
          display: flex;
          justify-content: flex-start;
          gap: 8px;
          align-items: center;
          justify-content: flex-start;
          width: fit-content;
          ${theme.font.family('boldWeb')};
          font-size: 14px;
          letter-spacing: 3px;
          text-transform: uppercase;
          :hover {
            color: #a1a2a3;
          }
          svg {
            color: inherit;
          }
        }
      `
    }
  };
};
